import * as React from 'react';
export const TripContext = React.createContext({
    trip: null,
    selectedBooking: null,
    onOpenCSRDialog: null,
    payBalanceEnabled: false,
    bundlePaymentEnabled: false,
    refresh: null,
});
